export enum NodeTypes {
  Start = 'Start',
  SendMessage = 'SendMessage',
  Randomizer = 'Randomizer',
  Delay = 'Delay',
  Conditions = 'Condition',
  SendInvoice = 'SendInvoice',
  Json = 'JsonRequest',
  RunFlow = 'RunFlow',
  EditLastMessage = 'EditLastMessage',
  CheckSubscription = 'CheckSubscription',
  PrivateMessage = 'SendPrivateMessage',
  CreateLimitedSubscription = 'CreateLimitedSubscription',
  Error = 'Error',
  Action = 'Action',
  CheckLimitedSubscription = 'CheckLimitedSubscription',
  InfoLimitedSubscription = 'InfoLimitedSubscription',
  ForwardMessage = 'ForwardMessage',
  CreateInviteLink = 'CreateInviteLink',
  HttpRequest = 'HttpRequest',
  Integration = 'Integration'
}

export type InactiveAction = {
  output: number
  time: number
}
